var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"google-button-black brdr-none w-100",on:{"click":_vm.onClick}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('Kup, używając')))]),_vm._v(" "),_c('span',{staticClass:"logo"})])}
var staticRenderFns = []

export { render, staticRenderFns }